import { useCallback, useEffect, useMemo, useState } from "react"

export default function hookReportViewStoreFactory(reportType) {
  const collectionURL = 'report-view'
  const collectionsURL = 'report-views'
  return ({ fetch, siteSelected, attachedToSite }) => {
    const [items, setItems] = useState([])

    const url = useMemo(() => {
      const { id } = siteSelected
      return attachedToSite ? `${collectionsURL}/site/${id}` : collectionsURL
    }, [siteSelected, attachedToSite])

    const reset = useCallback(() => {
      setItems([])
    }, [])

    useEffect(() => () => {
      reset()
    }, [reset])

    const parseParams = useCallback((params = {}) => {
      const { id: siteId, key: siteKey } = siteSelected
      return { ...params, reportType, [siteKey]: siteId }
    }, [siteSelected])

    const list = useCallback(async params => {
      const { rows } = await fetch({
        url,
        params: parseParams(params),
      })
      setItems(rows)
    }, [url, fetch, parseParams])

    const save = useCallback(async payload => {
      const { id } = payload
      return await fetch({
        method: id ? 'put' : 'post',
        url: id ? `${collectionURL}/${id}` : url,
        data: { ...payload, reportType },
        params: parseParams(),
      })
    }, [url, fetch, parseParams])

    const deleteEntry = useCallback(async entry => await fetch({
      method: "delete",
      url: `${collectionURL}/${entry.id}`,
      data: entry,
    }), [fetch])

    return useMemo(() => ({
      reportView: {
        items, reset, list, deleteEntry,

        useLoad: params => {
          useEffect(() => {
            list(params)
          }, [params])

          return useCallback(() => list(params), [params])
        },

        useSubmit: () => useCallback(payload => save(payload), []),
      },
    }), [items, reset, list, deleteEntry, save])
  }
}
